import styled from '@emotion/styled'

const StyledLabel = styled.label`
  margin-left: 4px;
  font-size: 0.875rem;
  color: #344357;
`

export default StyledLabel
